import React, { useState } from 'react'
import messages from './messages'
import { useIntl } from 'react-intl'
import { Modal, Button, Input } from '@arnsbogroup/react-voicearchive'
import NiceModal, { useModal } from '@ebay/nice-modal-react'

export default NiceModal.create(({ order }) => {
  const { formatMessage } = useIntl()
  const [loading, setLoading] = useState(false)
  const [title, setTitle] = useState('')
  const modal = useModal()

  const onSubmit = (event) => {
    setLoading(true)
    event.preventDefault()

    fetch(`/ordertask/createdefaultjob.html`, {
      method: 'POST',
      body: new URLSearchParams({
        orderid: order.uid,
        title,
      })
    })
      .then(() => {
        modal.resolve()
        modal.remove()
        setLoading(false)
      })
      .catch((error) => toastr.error(error))
  }

  return (
    <Modal
      show={modal.visible}
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      onSubmit={() => (!title.length || loading) ? undefined : onSubmit()}
      title={formatMessage(messages.title)}
    >
      <form onSubmit={onSubmit} className="space-y-4">
        <Input
          label="Title"
          value={title}
          onChange={({ target: { value } }) => setTitle(value)}
        />

        <Button
          type="submit"
          size="sm"
          disabled={!title.length || loading}
        >
          { loading ? 'Sending..' : 'Create' }
        </Button>
      </form>
    </Modal>
  )
})
